import { HTMLProjectionNode } from 'motion-dom';
import { MeasureLayout } from './layout/MeasureLayout.mjs';

const layout = {
    layout: {
        ProjectionNode: HTMLProjectionNode,
        MeasureLayout,
    },
};

export { layout };
//# sourceMappingURL=layout.mjs.map
